module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade-in"
  }, [_c('div', {
    staticClass: "container slide-in"
  }, [(_vm.mode) ? _c('div', [_c('h1', [_vm._v(" " + _vm._s(_vm.playerName))]), _vm._v(" "), _c('h2', [_vm._v("תוצאה : " + _vm._s(_vm.scores.playerOne.total) + "/10")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "direction": "rtl",
      "margin": "10px"
    }
  }, [_vm._v(_vm._s(_vm.scoreMessage))])]) : _vm._e(), _vm._v(" "), (!_vm.mode) ? _c('div', [(_vm.scores.playerOne.total > _vm.scores.playerTwo.total) ? _c('h1', [_vm._v("Player One Wins!")]) : _vm._e(), _vm._v(" "), (_vm.scores.playerTwo.total > _vm.scores.playerOne.total) ? _c('h1', [_vm._v("Player Two Wins!")]) : _vm._e(), _vm._v(" "), (_vm.scores.playerOne.total === _vm.scores.playerTwo.total) ? _c('h1', [_vm._v("Draw!")]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Player One: "), _c('span', {
    class: _vm.scores.playerOne.total >= _vm.scores.playerTwo.total ? 'score-high' : 'score-low'
  }, [_vm._v(_vm._s(_vm.scores.playerOne.total))])]), _vm._v(" "), _c('h2', [_vm._v("Player Two: "), _c('span', {
    class: _vm.scores.playerTwo.total >= _vm.scores.playerOne.total ? 'score-high' : 'score-low'
  }, [_vm._v(_vm._s(_vm.scores.playerTwo.total))])])]) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.newGame(true)
      }
    }
  }, [_vm._v("משחק חדש")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89c4e9c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameOverModal.vue
// module id = 51
// module chunks = 0